module.exports = __webpack_public_path__ + "img/i-sold-that.32dad707.png";